/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureAccountConfigInput {
  /**
  * The tenant ID
  */
  'tenantId': string;
  /**
  * The application ID
  */
  'applicationId'?: string;
  /**
  * The resource group name
  */
  'resourceGroup'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureAccountConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}

